<template>
    <div class="signup-container flex-center-hori">
        <div class="content flex-center-hori">
            <div class="signup-box-wrapper">
            <div class="signup-box">
                <div class="signup-title">佳都知行助手体验邀请函</div>
                <div class="signup-top">
                    <div>感谢您对佳都知行助手的关注！请您阅读如下说明：</div>
                    <li>近期我们仅能提供有限的体验名额，并会优先向我们的潜在客户发放体验邀请，请您谅解！</li>
                    <li>您根据真实情况填写表单，我们将通过短信通知您申请结果。</li>
                </div>
                <div class="signup-mid">
                    <el-form ref="form" :model="form" label-width="90px" :rules="rules">
                        <el-form-item label="真实姓名：" prop="nickname">
                            <el-input v-model="form.nickname" placeholder="请输入真实姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="mobile">
                            <el-input v-model="form.mobile" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱：" prop="email">
                            <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="登录密码：" prop="password">
                            <img
                                class="show-password"
                                :src="showPass? require('@/theme/images/icons/icon_eye_hidden.svg'):require('@/theme/images/icons/icon_eye_outline.svg') "
                                @click="showPass = !showPass"
                            >
                            <el-input
                                v-model="form.password"
                                class="password-input"
                                :type="showPass ? 'text' : 'password'"
                                placeholder="请输入密码"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码：" prop="confirmPassword">
                            <img
                                class="show-password"
                                :src="showConfirmPass? require('@/theme/images/icons/icon_eye_hidden.svg'):require('@/theme/images/icons/icon_eye_outline.svg') "
                                @click="showConfirmPass = !showConfirmPass"
                            >
                            <el-input
                                v-model="form.confirmPassword"
                                class="password-input"
                                :type="showConfirmPass ? 'text' : 'password'"
                                placeholder="请再次输入登录密码">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="您的职业：" prop="career">
                            <el-input v-model="form.career" placeholder="请输入您的职业"></el-input>
                        </el-form-item>
                        <el-form-item label="单位名称：" prop="workUnit">
                            <el-input v-model="form.workUnit" placeholder="请输入单位名称"></el-input>
                        </el-form-item>
                        <el-form-item label="需求场景：" prop="requirement">
                            <el-input v-model="form.requirement" placeholder="请输入需求场景"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="agreement">
                        <el-checkbox v-model="agree">我已阅读并同意<span class="link" @click="gotoServiceAgreement">服务协议</span>与<span class="link" @click="gotoPrivacyPolicy">隐私政策</span></el-checkbox>
                        <div class="input-note warn" v-if="agreeErr">请勾选“接受用户协议”</div>
                    </div>
                </div>
                <div class="signup-bottom">
                    <div
                        class="signup-button flex-center-hori"
                        @click="apply"
                    >
                        <div v-if="!applying">立即申请</div>
                        <div v-else>申请中...</div>
                    </div>
                    <div @click="gotoLogin" class="link">前往登录</div>
                </div>
                <img class="signup-img-bottom" src="@/theme/images/signup-bottom.png" alt="">
            </div>
            <img class="signup-img-top" src="@/theme/images/signup-top.png" alt="">
        </div>
        <img class="signup-img-behind" src="@/theme/images/signup-behind.png" alt="">
        </div>
    </div>
</template>

<script>
import accountAPI from '@/api/account.api.js';
export default {
    name: 'signup',
    data () {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入登录密码'));
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        return {
            form: {
                nickname: '',
                mobile: '',
                email: '',
                password: '',
                confirmPassword: '',
                career: '',
                workUnit: '',
                requirement: ''
            },
            agree: false,
            agreeErr: false,
            applying: false,
            showPass: false,
            showConfirmPass: false,
            rules: {
                nickname: [
                    { required: true, message: '请输入真实姓名' }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话' },
                    { pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|16[56]|17[012345678]|18[0-9]|19[89]|14[456789])[0-9]{8}$/, message: '请输入正确格式，错误的联系电话将无法收到申请结果' }
                ],
                email: [
                    { pattern: /^[A-Za-z0-9u4e00-u9fa5\s]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/, message: '请输入正确格式的邮箱地址' }
                ],
                password: [
                    { required: true, message: '请输入登录密码' },
                    { min: 6, max: 16, message: '长度在6到16个字符' }

                ],
                confirmPassword: [
                    { required: true, message: '请再次输入登录密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
                career: [
                    { required: true, message: '请输入您的职业' }
                ],
                workUnit: [
                    { required: true, message: '请输入单位名称' }
                ]
            }
        };
    },
    computed: {
    },
    methods: {
        apply () {
            if (!this.agree) {
                this.agreeErr = true;
                return;
            } else {
                this.agreeErr = false;
            }
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.applying = true;
                    try {
                        let res = await accountAPI.register(this.form);
                        if (res.data) {
                            this.$message.success('成功提交申请！');
                            this.$refs.form.resetFields();
                        }
                    } catch (error) {
                        this.applying = false;
                        this.$message.error(error.message);
                    }
                    this.applying = false;
                }
            });
        },
        // 打开服务协议
        gotoServiceAgreement () {

        },
        // 打开隐私政策
        gotoPrivacyPolicy () {

        },
        //  前往登录
        gotoLogin () {
            this.$router.replace({ path: '/login' });
        }
    }
};
</script>
<style scoped lang="scss">
.signup-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    background: url(~@/theme/images/bg_login_light.png);
    background-size: cover;
    overflow: auto;
    .content{
        height:874px;
        width: 799px;
        position: relative;
        .signup-img-behind{
        position: absolute;
        bottom: 86px;
        width: 620px;
        height: 120px;
        }
    }

    .signup-box-wrapper{
        z-index: 1;
        width: 560px;
        height:874px;
        padding: 16px;
        box-sizing: border-box;
        border-radius: 8px;
        background: #FFFFFF linear-gradient(180deg, #F2F7FF 0%, #FFFFFF 100%);
        box-shadow: 0px 2px 6px 0px rgba(7, 22, 51, 0.06);
        border: 2px solid;
        border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0)) 2 2;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .signup-img-top{
            position: absolute;
            right: 0;
            top: 0;
            width: 150px;
            height: 150px;
            z-index: 0;
        }
    }

    .signup-box {
        z-index: 1;
        position: relative;
        width: 528px;
        height: 767px;
        border: 2px solid;
        box-sizing: border-box;
        border-image: linear-gradient(360deg, rgba(248, 250, 255, 1), rgba(225, 235, 255, 1)) 2 2;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: space-between;
        .signup-img-bottom{
            position: absolute;
            left: -131px;
            bottom: -92px;
            width: 799px;
            height: 257px;
            z-index: -1;
        }
        .signup-title {
            text-align: center;
            font-size: 40px;
            margin-top: 16px;
            font-family: SourceHanSansSC-Bold, SourceHanSansSC;
            font-weight: bold;
            color: #3B77FF;
            line-height: 56px;
            background: linear-gradient(270deg, #165DFF 0%, #209BFF 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .signup-top,
        .signup-bottom {
            width: 100%;
            flex: 0 0 auto;
        }

        .signup-top{
            padding: 24px 40px;
            font-size: 12px;
            color: rgba(7, 22, 51, 0.45);
            line-height: 18px;
        }

        .signup-mid {
            width: 100%;
            flex: 1 1 auto;
            padding: 0 40px;
            .el-form{
                &-item{
                    margin-bottom: 12px;
                    .show-password {
                        z-index: 1;
                        height: 16px;
                        margin: 16px;
                        position: absolute;
                        right: 0;
                        top: 0;
                        cursor: pointer;
                    }
                    ::v-deep{
                        .el-form-item__label{
                            padding-right: 0;
                        }
                        .el-form-item__error{
                            padding-left: 8px;
                        }
                        .el-input__inner{
                            border: none;
                            border-bottom: 1px solid rgba(7, 22, 51, 0.1000);
                            border-radius: 0;
                            background: transparent;
                            padding: 8px
                        }
                    }
                }
            }
            .input-note.warn {
                text-align: left;
                font-size: 14px;
                line-height: 19px;
                color: red;
            }
            .agreement{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 16px;
                ::v-deep{
                    .el-checkbox{
                        &__label{
                            cursor: default;
                            color: rgba(7, 22, 51, 0.45);
                        }
                }
                }
            }
        }

        .signup-bottom {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            margin-bottom: 24px;
            margin-top: 16px;

            .signup-button {
                width: 400px;
                height: 48px;
                background: #126CFF;
                border-radius: 4px;
                user-select: none;
                cursor: pointer;
                margin-bottom: 8px;

                >div {
                    font-size: 16px;
                    font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 30px;
                    letter-spacing: 4px;
                }
            }
        }

        .link{
            font-size: 14px;
            color: rgba(18, 108, 255, 1) ;
            cursor: pointer;
            &:hover{
                    text-decoration: underline;
                }
        }
    }
}</style>
